"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var SchoolRequest;
(function (SchoolRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.email = undefined;
            _this.address = undefined;
            _this.instituteName = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            _this.facebookId = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    SchoolRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.email = undefined;
            _this.address = undefined;
            _this.instituteName = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    SchoolRequest.Update = Update;
})(SchoolRequest = exports.SchoolRequest || (exports.SchoolRequest = {}));
var SchoolResponse;
(function (SchoolResponse) {
    var School = (function (_super) {
        __extends(School, _super);
        function School() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.email = undefined;
            _this.userRoleId = undefined;
            _this.address = undefined;
            _this.number = undefined;
            _this.apt = undefined;
            _this.city = undefined;
            _this.departament = undefined;
            _this.zip = undefined;
            _this.instituteName = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return School;
    }(BaseModel_1["default"]));
    SchoolResponse.School = School;
    var All = (function () {
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            this.objects = undefined;
            this.length = 0;
            this.offset = 0;
            this.pagination = 100;
            this.objects = objects;
            this.length = length;
            this.offset = offset;
            this.pagination = pagination;
        }
        return All;
    }());
    SchoolResponse.All = All;
})(SchoolResponse = exports.SchoolResponse || (exports.SchoolResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/school.js
// module id = ../model/dist/models/school.js
// module chunks = main